// Global Instructions Rule Applied!

import React from 'react'

const SKIP_ROW_KEYS = new Set(['id', 'key'])

/**
 * True when any non-skipped string field contains "total" (case-insensitive).
 * Used to style summary/total rows in tables (e.g. Schedule of Investments).
 */
export function recordHasTotalLabel(record: object): boolean {
  for (const [key, v] of Object.entries(record)) {
    if (SKIP_ROW_KEYS.has(key)) continue
    if (typeof v === 'string' && v.toLowerCase().includes('total')) {
      return true
    }
  }
  return false
}

/** Removes "total" (case-insensitive) from a string; collapses whitespace. */
export function stripTotalWordFromString(str: string): string {
  return str.replace(/total/gi, '').replace(/\s+/g, ' ').trim()
}

/**
 * Applies {@link stripTotalWordFromString} to string children in a cell render (e.g. div-wrapped numbers).
 */
export function stripTotalTextFromCellNode(node: React.ReactNode): React.ReactNode {
  if (node == null || node === false) return node
  if (typeof node === 'string') {
    const s = stripTotalWordFromString(node)
    return s === '' ? '' : s
  }
  if (typeof node === 'number' || typeof node === 'boolean') return node
  if (React.isValidElement(node)) {
    const el = node as React.ReactElement<{ children?: React.ReactNode }>
    const ch = el.props.children
    if (ch !== undefined && ch !== null) {
      const newChildren = React.Children.map(ch, (child) => {
        if (typeof child === 'string') {
          const s = stripTotalWordFromString(child)
          return s === '' ? null : s
        }
        return child
      })
      return React.cloneElement(el, { children: newChildren })
    }
  }
  return node
}
